import { IconArrowDropDown } from 'assets/icons';
import { qnTexts } from '../themes/_palette';

import IconCalendar from 'assets/icons/Calendar';

export const MuiDesktopDatePicker = {
    defaultProps: {
        components: { 
            OpenPickerIcon: () => <IconCalendar sx={{ mr: 0.5 }} />
        }
    }
}
